import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BehaviorSubject, Subject} from 'rxjs';
import {CookieService} from 'ngx-cookie-service';
import {User} from "../models";


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  loggedIn$ = new BehaviorSubject(false);
  user$ = new BehaviorSubject<User>(null);
  login$ = new Subject();
  logout$ = new Subject();

  constructor(private http: HttpClient,
              private router: Router,
              private snackBar: MatSnackBar,
              private cookieService: CookieService) {

      this.getUser();
    }

  getUser() {
    this.http.get('/api/auth/im/').subscribe(
      (v: User) => {
        if (v) {
          this.loggedIn$.next(true);
          this.user$.next(v);
        }
      }
    );
  }

  getCSRF() {
    this.http.get('/api/auth/csrf/').subscribe(
      (response) => {
        console.log(response);
      }
    );
  }

  login(login, password) {

    this.http.post('/api/auth/login/', {login, password}, {withCredentials: true}).subscribe(
      (response) => {
        this.loggedIn$.next(true);
        this.login$.next(true);
        this.getUser();
        this.router.navigate(['/']);
        this.snackBar.open(
          'Вход выполнен',
          null,
          {
            duration: 2500
          }
        );
      }
    );
  }

  logout() {
    this.logout$.next(true);
    this.http.post('/api/auth/logout/', {}, {withCredentials: true}).subscribe(() => {
      this.loggedIn$.next(false);
      this.user$.next(null);
      this.router.navigate(['/auth']);
    });
  }

  ping() {
    return this.http.get('/api/ping/');
  }

}
